<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">广告管理</div>

      <div class="search-wrapper">
         <h2>广告间隔管理</h2>
      </div>

      <div class="flex-row-between margin-20">
         <el-button type="primary" icon="plus" @click="openCampus(null)">学校个性化</el-button>
         <div>
            <el-button type="text" v-show="!isEdit" @click="isEdit = !isEdit">编辑</el-button>
            <el-button type="text" v-show="isEdit" @click="handleCancel">取消</el-button>
            <el-button type="text" v-show="isEdit" @click="handleSubmit">保存</el-button>
         </div>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border v-loading="loading">
            <el-table-column v-for="item in tableHeader" :key="item.value" :label="item.label" align="center"
               inline-template>
               <template>
                  <div v-if="$index === 0" class="hotLoad">
                     <span>热启动间隔</span>
                     <span v-show="!isEdit">{{ row[item.value] || 0 }}</span>
                     <el-input-number v-show="isEdit" v-model="row[item.value]" :min="0" size="small" />秒
                  </div>
                  <div v-if="$index === 1">冷启动间隔{{ row[item.value] || 0 }}秒</div>
               </template>
            </el-table-column>
         </el-table>
         <div class="diy-list">
            <div class="diy-item" v-for="item in hotSpots" :key="item.key">
               <div class="title">
                  <span>
                     【热启动】开屏{{ item.openScreenAd }}秒；首页弹窗{{ item.homeScreenAd }}秒；我的{{ item.myInformationFlowAd }}秒
                  </span>
                  <div class="op-list">
                     <el-button type="text" @click="openCampus(item)">编辑</el-button>
                     <el-button type="text" style="color: red" @click="caDel(item)">删除</el-button>
                  </div>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="mo in item.models" :key="mo.unid">
                        {{ mo.name }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ item.models.length }}所学校</div>
            </div>
         </div>
      </div>

      <div class="search-wrapper">
         <h2>倍孜广告开关</h2>
         <el-switch v-model="value" on-text off-text @change="bindSwitchChange"></el-switch>
      </div>

      <div class="content-wrapper">
         <div class="check-date" v-if="value">
            <div>每周策略</div>
            <el-checkbox-group v-model="dateChecked">
               <el-checkbox v-for="(item, index) in dateOptions" :key="index" :label="item.value"
                  :disabled="!dateEditing">
                  {{ item.label }}
               </el-checkbox>
            </el-checkbox-group>
            <el-button v-if="!dateEditing" type="text" @click="clickDateCheck(1)">编辑</el-button>
            <el-button v-if="dateEditing" type="text" @click="clickDateCheck(2)">保存</el-button>
            <el-button v-if="dateEditing" type="text" style="color: #666;" @click="clickDateCheck(3)">取消</el-button>
         </div>
      </div>

      <div class="search-wrapper">
         <h2>广告屏蔽校区</h2>
         <el-switch v-model="schoolAreaAdShield" on-text off-text @change="changeSchoolAreaAdShield"></el-switch>
      </div>

      <div class="content-wrapper margin-top-10 margin-bottom-20">
         <div class="diy-list">
            <div class="diy-item">
               <div class="title">
                  <span>插屏（首页）</span>
                  <el-button type="text" @click="handleEditCampus('homeAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in homeAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ homeAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>开屏</span>
                  <el-button type="text" @click="handleEditCampus('openAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in openAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ openAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>插屏（跑步结束页）</span>
                  <el-button type="text" @click="handleEditCampus('runAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in runAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ runAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>信息流（我的）</span>
                  <el-button type="text" @click="handleEditCampus('flowAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in flowAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ flowAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>无障碍校区屏蔽</span>
                  <el-button type="text" @click="handleEditCampus('barrierFree')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in barrierFree" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ barrierFree.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>信息流（首页）</span>
                  <el-button type="text" @click="handleEditCampus('homeFlowAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in homeFlowAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ homeFlowAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>信息流（跑步结束页）</span>
                  <el-button type="text" @click="handleEditCampus('runFlowAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in runFlowAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ runFlowAd.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>悬浮窗广告屏蔽</span>
                  <el-button type="text" @click="handleEditCampus('floatingAd')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in floatingAd" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ floatingAd.length }}所学校</div>
            </div>
         </div>
      </div>

      <div class="search-wrapper">
         <h2>安卓-广告分配管理</h2>
      </div>

      <div class="flex-row gap-20 margin-top-20 margin-left-20">
         <el-button>
            <a href="https://admin.gxapp.iydsj.com/template/ad_config.xlsx">模板下载</a>
         </el-button>
         <el-upload :with-credentials='true' name="uploadFile" :action="configActionUrl"
            :before-upload="beforeConfigUpload" :on-success="handleConfigSuccess" :on-error="handleConfigError">
            <el-button type="primary">导入</el-button>
         </el-upload>
      </div>

      <div class="content-wrapper margin-bottom-20">
         <div class="diy-list">
            <div class="diy-item">
               <div class="title">
                  <span>倍孜</span>
                  <el-button type="text" @click="handleEditCampus('beiziConfigs')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in beiziConfigs" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ beiziConfigs.length }}所学校</div>
            </div>
            <div class="diy-item">
               <div class="title">
                  <span>美数</span>
                  <el-button type="text" @click="handleEditCampus('meishuConfigs')">编辑</el-button>
               </div>
               <div class="card-wrap">
                  <el-row :gutter="16">
                     <el-col class="card-item" :span="6" v-for="item in meishuConfigs" :key="item.value">
                        {{ item.label }}
                     </el-col>
                  </el-row>
               </div>
               <div class="card-footer">共计{{ meishuConfigs.length }}所学校</div>
            </div>
         </div>
      </div>

      <DiyCampusDialog ref="DiyCampusRef" :CampusZoneList="CampusZoneList" @getData="getHotSpots" />
      <EditCampusDialog ref="editCampusRef" :campusZoneList="CampusZoneList" @refreshCampusData="refreshCampusData" />
   </div>
</template>

<script>
import DiyCampusDialog from './Components/DiyCampusDialog.vue';
import EditCampusDialog from './Components/EditCampusDialog.vue';

export default {
   components: {
      DiyCampusDialog,
      EditCampusDialog,
   },

   data() {
      return {
         loading: false,
         CampusZoneList: [],

         isEdit: false,
         tableHeader: [{
            label: "开屏广告",
            value: "hotSplash",
         }, {
            label: "首页弹窗广告",
            value: "reverseHome",
         }, {
            label: "我的页面广告",
            value: "mine",
         }],
         tableData: [{
            hotSplash: 0,
            reverseHome: 0,
            mine: 0,
         }, {
            hotSplash: 0,
            reverseHome: 0,
            mine: 0,
         }],
         resetData: {
            hotSplash: 0,
            reverseHome: 0,
            mine: 0,
         },
         hotSpots: [],

         value: false,
         dateOptions: [
            { label: '周一', value: 1 },
            { label: '周二', value: 2 },
            { label: '周三', value: 3 },
            { label: '周四', value: 4 },
            { label: '周五', value: 5 },
            { label: '周六', value: 6 },
            { label: '周日', value: 7 },
         ],
         dateDefault: [1, 2, 3, 4, 5, 6, 7],
         dateOrigin: [1, 2, 3, 4, 5, 6, 7],
         dateChecked: [1, 2, 3, 4, 5, 6, 7],
         dateEditing: false,

         schoolAreaAdShield: false,
         homeAd: [],
         flowAd: [],
         openAd: [],
         runAd: [],
         barrierFree: [], // 无障碍
         homeFlowAd: [], // 首页信息流
         runFlowAd: [], // 跑步结束页信息流
         floatingAd: [], // 悬浮窗广告屏蔽

         beiziConfigs: [], // 倍孜
         meishuConfigs: [], // 美数
         configActionUrl: `${this.$util.domain}/adminapi/v2/ad/distribution/import`,
      }
   },

   mounted() {
      this.apiGetCampusZones();
      this.getDataSource();
      this.getHotSpots();
      this.apiGetSwitchValue();

      this.querySchoolAreaAdShield();
      this.apiGetShieldAd();
      this.apiGetBarrierFree();

      this.queryAdConfigureList(1);
      this.queryAdConfigureList(2);
   },

   methods: {
      // 获取校区
      apiGetCampusZones() {
         this.$http({
            url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
            method: "GET",
         }).then((res) => {
            if (res.body.data && res.body.data.length) {
               this.CampusZoneList = res.body.data.map((item) => ({
                  label: item.name,
                  value: item.unid,
               }));
            } else {
               this.CampusZoneList = [];
            }
         }).catch((error) => {
            this.CampusZoneList = [];
         });
      },
      // 获取广告时间间隔
      async getDataSource() {
         try {
            this.isEdit = false;
            this.loading = true;
            const result = await this.$http({
               method: "GET",
               url: this.$util.domain + "/adminapi/v2/ad/getAdTimeInterval",
            });
            if (result.body.data && JSON.stringify(result.body.data) !== "{}") {
               this.resetData = result.body.data;
               const dataSource = JSON.parse(JSON.stringify(result.body.data));
               this.tableData[0].hotSplash = dataSource.hotSplash;
               this.tableData[0].reverseHome = dataSource.reverseHome;
               this.tableData[0].mine = dataSource.mine;
            }
         } catch (error) {
            this.tableData[0] = {
               hotSplash: 0,
               reverseHome: 0,
               mine: 0,
            };
         } finally {
            this.loading = false;
         }
      },
      // 获取广告间隔管理个性化校区
      async getHotSpots() {
         const res = await this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v2/ad/personalizedHotSpots/detail",
         });
         if (res.data.error === 10000) {
            this.hotSpots = res.data.data;
         } else {
            this.$message.error(res.data.message || "获取个性化失败");
         }
      },
      // 点击学校个性化
      openCampus(item) {
         this.$refs.DiyCampusRef.show(item);
      },
      // 取消广告间隔管理操作
      handleCancel() {
         this.isEdit = false;
         const dataSource = JSON.parse(JSON.stringify(this.resetData));
         this.tableData[0].hotSplash = dataSource.hotSplash;
         this.tableData[0].reverseHome = dataSource.reverseHome;
         this.tableData[0].mine = dataSource.mine;
      },
      // 保存广告间隔管理操作
      async handleSubmit() {
         try {
            this.loading = true;
            const result = await this.$http({
               method: "POST",
               url: this.$util.domain + "/adminapi/v2/ad/setAdTimeInterval",
               body: JSON.stringify({
                  ...this.tableData[0],
               }),
            });
            if (result.body.error === 10000) {
               this.$message({
                  type: "success",
                  message: "操作成功!",
               });
            } else {
               this.$message({
                  type: "error",
                  message: result.body.message,
               });
            }
         } catch (error) {
            this.$message({
               type: "error",
               message: "操作失败，请稍后再试!",
            });
         } finally {
            this.loading = false;
            this.getDataSource();
         }
      },
      // 删除个性化校区
      async caDel(item) {
         await this.$confirm("确认要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         });
         const res = await this.$http({
            url: `${this.$util.domain}/adminapi/v2/ad/personalizedHotSpots/addOrEdit`,
            method: "post",
            body: JSON.stringify({ ...item, models: [] }),
         });
         if (res.data.error === 10000) {
            this.$message.success("删除成功");
            this.getHotSpots();
         } else {
            this.$message.error("删除失败");
         }
      },


      // 获取倍孜广告开关信息
      apiGetSwitchValue() {
         this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v2/ad/getAdOpen",
         }).then((res) => {
            if (res.data.data) {
               this.value = res.data.data.status === 1;
               if (res.data.data.week) {
                  const origin = res.data.data.week.split(',').map((item) => Number(item) || 0);
                  this.dateOrigin = this.dateDefault.filter((item) => !origin.includes(item));
                  this.dateChecked = this.dateOrigin;
               }
            } else {
               this.value = false;
               this.dateOrigin = defaultChecked;
            }
         }).catch((error) => {
            this.value = false;
         });
      },
      // 编辑倍孜广告开关
      bindSwitchChange(value) {
         this.$http({
            url: this.$util.domain + "/adminapi/v2/ad/editAdOpen",
            method: "POST",
            dataType: "json",
            body: JSON.stringify({
               status: value ? 1 : 0,
            }),
         }).then((res) => {
            if (res.body.error !== 10000) {
               this.$util.errorMsg(res.body.message);
               this.value = value ? false : true;
            } else {
               this.getDataSource();
            }
         }).catch((error) => {
            this.$util.errorMsg("请重试");
            this.value = value ? false : true;
         });
      },
      // 倍孜广告日期选择
      clickDateCheck(type) {
         this.dateEditing = type == 1;
         if (type == 1) {

         } else if (type == 2) {
            this.apiEditAdWeekConfig();
         } else if (type == 3) {
            this.dateChecked = this.dateOrigin;
         }
      },
      // 倍孜广告每周策略配置
      apiEditAdWeekConfig() {
         const dateParam = this.dateDefault.filter((item) => !this.dateChecked.includes(item));
         const param = { week: dateParam.length ? dateParam.join(',') : 0 };
         this.$http({
            method: 'POST',
            url: this.$util.domain + '/adminapi/v2/ad/editAdWeekConfig',
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error !== 10000) {
               this.$util.errorMsg(res.body.message);
               this.dateChecked = this.dateOrigin;
            }
         }).catch((error) => {
            this.$util.errorMsg("请重试");
            this.dateChecked = this.dateOrigin;
         }).finally(() => {
            this.apiGetSwitchValue();
         });
      },


      // 查询广告屏蔽校区开关
      querySchoolAreaAdShield() {
         this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v2/ad/allShield/get',
         }).then((res) => {
            this.schoolAreaAdShield = res.body.data ? true : false;
         }).catch((error) => {
            this.schoolAreaAdShield = false;
         });
      },
      // 切换广告屏蔽校区开关
      changeSchoolAreaAdShield(value) {
         this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v2/ad/allShield/edit',
            params: { open: value ? 1 : 0 },
         }).then((res) => {
            if (res.body.error !== 10000) {
               this.$util.errorMsg(res.body.message);
               this.schoolAreaAdShield = value ? false : true;
            }
         }).caDel((error) => {
            this.$util.errorMsg('请重试');
            this.schoolAreaAdShield = value ? false : true;
         });
      },
      // 获取广告屏蔽校区
      apiGetShieldAd() {
         this.$http({
            url: this.$util.domain + "/adminapi/v2/ad/getShieldAd",
            method: "GET",
         }).then((res) => {
            if (res.body.data && res.body.data.length) {
               const dataSource = res.body.data;
               dataSource.forEach((item) => {
                  item.campusZones = item.campusZones || [];
                  if (item.type === "SHIELD_HOME_SCREEN_AD") {
                     this.homeAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "SHIELD_MINE_INFORMATION_FLOW_AD") {
                     this.flowAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "SHIELD_OPEN_SCREEN_AD") {
                     this.openAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "SHIELD_RUN_SCREEN_AD") {
                     this.runAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "HOME_INFORMATION_AD") {
                     this.homeFlowAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "SHIELD_RUN_END_FEED_AD") {
                     this.runFlowAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  } else if (item.type === "SHIELD_FLOATING_AD") {
                     this.floatingAd = item.campusZones.map((item) => ({
                        label: item.name,
                        value: item.unid,
                     }));
                  }
               });
            } else {
               this.homeAd = [];
               this.flowAd = [];
               this.openAd = [];
               this.runAd = [];
               this.homeFlowAd = [];
               this.runFlowAd = [];
               this.floatingAd = [];
            }
         }).catch((error) => {
            this.homeAd = [];
            this.flowAd = [];
            this.openAd = [];
            this.runAd = [];
            this.homeFlowAd = [];
            this.runFlowAd = [];
            this.floatingAd = [];
         });
      },
      // 获取无障碍屏蔽校区
      apiGetBarrierFree() {
         this.$http({
            url: this.$util.domain + "/adminapi/v1/barrierFree/getBarrierFree",
            method: "GET",
         }).then((res) => {
            if (res.body.data && res.body.data.length) {
               this.barrierFree = res.body.data.map((item) => ({
                  label: item.name,
                  value: item.unid,
               }));
            }
         });
      },
      // 点击校区编辑按钮
      handleEditCampus(type) {
         this.$refs.editCampusRef.show({
            type: type,
            data: [...this[type]]
         });
      },
      // 获取屏蔽校区
      refreshCampusData(type) {
         if (type === "barrierFree") { // 无障碍屏蔽
            this.apiGetBarrierFree();
         } else if (type === "beiziConfigs") { // 倍孜配置
            this.queryAdConfigureList(1);
         } else if (type === "meishuConfigs") { // 美数配置
            this.queryAdConfigureList(2);
         } else {
            this.apiGetShieldAd();
         }
      },


      // 获取广告配置列表, type 1倍兹 2美数
      queryAdConfigureList(type) {
         this.$http({
            url: this.$util.domain + "/adminapi/v2/ad/distribution/list",
            method: "GET",
            params: { type }
         }).then((res) => {
            if (type == 1) {
               if (res.body.data && res.body.data.length) {
                  this.beiziConfigs = res.body.data.map((item) => ({
                     label: item.campusName,
                     value: item.unid
                  }));
               } else {
                  this.beiziConfigs = [];
               }
            } else if (type == 2) {
               if (res.body.data && res.body.data.length) {
                  this.meishuConfigs = res.body.data.map((item) => ({
                     label: item.campusName,
                     value: item.unid
                  }));
               } else {
                  this.meishuConfigs = [];
               }
            }
         }).catch((err) => {
            if (type == 1) {
               this.beiziConfigs = [];
            } else if (type == 2) {
               this.meishuConfigs = [];
            }
         })
      },
      // 导入广告配置之前
      beforeConfigUpload() {
         this.loading = true;
      },
      // 导入广告配置成功
      handleConfigSuccess(response) {
         this.loading = false;
         if (response.error === 10000) {
            this.$util.successMsg(response.message);
            this.queryAdConfigureList(1);
            this.queryAdConfigureList(2);
         } else {
            this.$util.errorMsg(response.message);
         }
      },
      // 导入广告配置失败
      handleConfigError(response) {
         this.loading = false;
         this.$util.errorMsg(response.message);
      },

   }
}
</script>

<style scoped>
.diy-list {
   display: flex;
   flex-wrap: wrap;
   gap: 0px 40px;
}

.diy-item {
   width: calc(50% - 20px);
   margin-top: 10px;
}

.diy-item .title {
   display: flex;
   align-items: center;
   justify-content: space-between;
}

.op-list {
   margin-left: 20px;
}

.card-wrap {
   box-sizing: border-box;
   width: 100%;
   height: 200px;
   overflow: auto;
   padding: 10px;
   margin: 8px 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}

.card-item {
   margin-bottom: 8px;
}

.search-wrapper h2 {
   margin-right: 20px;
}

.check-date {
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: 10px;
   font-size: 14px;
}

.check-date .el-button:nth-child(3) {
   margin-left: 30px;
}
</style>


// WEBPACK FOOTER //
// AdManagement.vue?3fcef8fc